module.exports = __webpack_public_path__ + "media/images/ac_templates/201/royht-cc4af8d88831eedbd52f40d70b14bbc1.jpg";